export enum AssignUserRequestTypeEnum {
  Assign = 'ASSIGN',
  UnAssign = 'UNASSIGN'
}
